import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { Roles } from '../models/rolesAndPermissions';
import { v4 as uuid } from 'uuid';

interface communicationInput {
  communicationAttachmentInput: string;
  communicationRoleInput: string;
  communicationMsg: string;
  getCommunicationInitScheme: any;
  communicationSubject: string;
  communicationModel: string;
  communicationModelSub: string;
  addNewCommunicationTab: any;
}

export default class CommunicationStore {
  communicationInput: communicationInput = {
    communicationAttachmentInput: '',
    communicationRoleInput: '',
    communicationMsg: '',
    getCommunicationInitScheme: [],
    communicationSubject: '',
    communicationModel: '',
    communicationModelSub: '',
    addNewCommunicationTab: [],
  };

  CommunicationRegistry = new Map<string, Roles>();
  selectedVault: Roles | undefined = undefined;
  loadingInitial = false;
  loading = false;
  isAddNewStatusTab = false;

  // Get input values from the Communication configuration component
  setCommunicationAttachmentInput = (data: string) => {
    this.communicationInput.communicationAttachmentInput = data;
  };

  getCommunicationRoleInput = (data: string) => {
    this.communicationInput.communicationRoleInput = data;
  };

  getCommunicationMsg = (data: string, ind: number) => {
    this.communicationInput.communicationMsg = data + '|' + ind;
  };

  getCommunicationSub = (data: string, ind: number) => {
    this.communicationInput.communicationSubject = data + '|' + ind;
  };

  // Set dummy template for all status of Communication in initial time
  setCommunicationScheme = (selected: any) => {
    let actionStatus = 0;
    switch (selected) {
      case 'Start':
        actionStatus = 1;
        break;
      case 'Complete':
        actionStatus = 2;
        break;
      case 'Hold':
        actionStatus = 3;
        break;
      case 'Resume':
        actionStatus = 4;
        break;
      case 'Reject':
        actionStatus = 5;
        break;
      case 'Rework':
        actionStatus = 6;
        break;
    }

    if (actionStatus !== 0) {
      const tabInitContent =
        'Dear Name<br/> This is a reminder for returning the Asset as the due date. Due Date has passed.<br/><br/>Thanks<br/>Admin Name';

      const communicationScheme = {
        id: uuid(),
        status: actionStatus,
        rolesId:
          this.communicationInput.communicationRoleInput !== ''
            ? this.communicationInput.communicationRoleInput
            : null,
        attachment:
          this.communicationInput.communicationAttachmentInput !== ''
            ? this.communicationInput.communicationAttachmentInput
            : null,
        subject: '',
        model:
          this.communicationInput.communicationModel !== ''
            ? this.communicationInput.communicationModel
            : null,
        modelSub:
          this.communicationInput.communicationModelSub !== ''
            ? this.communicationInput.communicationModelSub
            : null,
        message: tabInitContent,
        email: null,
        email_copy: null,
        isNotification: false,
        conditons: '',
        dateOccurane: '',
        notificationOccurance: '',
        notificationContentId: '',
      };
      this.communicationInput.getCommunicationInitScheme = [
        ...this.communicationInput.getCommunicationInitScheme,
        communicationScheme,
      ];
      this.communicationInput.addNewCommunicationTab = [communicationScheme];
    }
  };

  setCommunicationScheme2 = (selected: any, selectedID: string) => {
    let actionStatus = 11;

    const tabInitContent =
      'Dear Name<br/> This is a reminder for returning the Asset as the due date. Due Date has passed.<br/><br/>Thanks<br/>Admin Name';

    const communicationScheme = {
      id: uuid(),
      status: actionStatus,
      rolesId:
        this.communicationInput.communicationRoleInput !== ''
          ? this.communicationInput.communicationRoleInput
          : null,
      attachment:
        this.communicationInput.communicationAttachmentInput !== ''
          ? this.communicationInput.communicationAttachmentInput
          : null,
      subject: '',
      model:
        this.communicationInput.communicationModel !== ''
          ? this.communicationInput.communicationModel
          : null,
      modelSub:
        this.communicationInput.communicationModelSub !== ''
          ? this.communicationInput.communicationModelSub
          : null,
      message: tabInitContent,
      email: null,
      email_copy: null,
      isNotification: true,
      notificationName: selected,
      conditons: '',
      dateOccurane: '',
      notificationOccurance: '',
      notificationContentId: selectedID,
    };
    this.communicationInput.getCommunicationInitScheme = [
      ...this.communicationInput.getCommunicationInitScheme,
      communicationScheme,
    ];
    this.communicationInput.addNewCommunicationTab = [communicationScheme];
  };
  //End

  get rolesData() {
    return Array.from(this.CommunicationRegistry.values());
  }

  constructor() {
    makeAutoObservable(this);
  }

  postCommunication = async (communicationData: any) => {
    try {
      await agent.communicationApi.create(communicationData);
      runInAction(() => {
        // toast.success('Auto save succefully');
        // const newAddData = communicationData.communication[0];
        // this.communicationInput.getCommunicationInitScheme = [...this.communicationInput.getCommunicationInitScheme, newAddData];
        // this.isAddNewStatusTab = true;
      });
    } catch (error) {
      toast.error('Communication Configuration Save failed');
    }
  };

  putCommunication = async (communicationData: any) => {
    try {
      const resp: any = await agent.communicationApi.update(communicationData);
      runInAction(() => {
        if (resp.data.isSuccess === false) {
          toast.error(resp.data.error);
        } else {
          toast.success('Communication Configuration updated successfully');
        }
      });
    } catch (error: any) {
      toast.error('Pls Try Again !');
    }
  };

  deleteCommunication = async (delComId: any, data: any) => {
    try {
      await agent.communicationApi.delComm(delComId);
      runInAction(() => {
        this.communicationInput.getCommunicationInitScheme = data;
        // this.communicationInput.getCommunicationInitScheme = this.communicationInput.getCommunicationInitScheme.filter((item: any) => item.id !== delComId)
        toast.success('Communication Configuration updated successfully');
      });
    } catch (error) {
      toast.error('Communication Configuration Save failed');
    }
  };
}
